import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "../../../../Translations/LenguageContext";
import ErrorMessage from "../../../../Components/ErrorMessage";
import Spinner from "../../../../Components/Spinner";

const DeleteDomainModal = ({ showDeleteDomain, closeDeleteDomains, GetDomains, domainDelete, domainType }) => {
    const { t } = useLanguage();
    const { project_id } = useParams();
    const user_id = sessionStorage.getItem("user_id");
    const [error, setError] = useState({ message: "", display: false });
    const [loading, setLoading] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [inputValue, setInputValue] = useState("");


    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);

        if (value === domainDelete) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    };

    const DeleteDomain = async () => {
        setLoading(true);
        setError({ message: "", display: false });
        const data = { 
            user_id, 
            project_id, 
            "customDomain": domainDelete, 
            "type" : domainType
        };


        try {
            const response = await fetch("https://aiservice.erioon.com/delete_domain", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
            });

            setLoading(false);

            const result = await response.json();
            if (response.ok) {
                setError({ message: "", display: false });

                GetDomains()
                handleCloseModal()
            } else {

                setError({ message: `Domain is not available`, display: true });
            }
        } catch (err) {
            setLoading(false);
            setError({ message: "Failed to save AI settings. Please try again later.", display: true });
        }
    };

    const handleCloseModal = () => {
        setIsButtonDisabled(true);
        closeDeleteDomains()
        setError({ message: "", display: false })
        setInputValue("")
    }

    return (
        <Modal show={showDeleteDomain} onHide={handleCloseModal} className="modal_delete">
            <div className="modal_header">
                <p>{t.delete_modal.title}</p>
                <i className="fa-solid fa-x" onClick={handleCloseModal}></i>
            </div>


            <div className="modal_body">
                <p className="warning_delete_message">This action CANNOT be undone. It will be permanently removed and no longer accessible through its URL.</p>
                <div className="delete_action_cont">
                    <p className="type_phrase_delete">{t.delete_modal.confirm_del_mex} <strong>{domainDelete}</strong></p>
                    <input
                        className="delete_input"
                        placeholder={domainDelete}
                        value={inputValue}
                        onChange={handleInputChange}
                    />
                </div>

            </div>

            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    <button
                        className={`delete_btn ${isButtonDisabled ? "" : "delete_btn_active"}`}
                        onClick={DeleteDomain}
                        disabled={isButtonDisabled}
                    >
                        {loading ? (
                            <Spinner loading={loading} />
                        ) : (
                            <>{t.delete}</>
                        )}
                    </button>
                    <button className="cancel_btn" onClick={handleCloseModal}>{t.cancel}</button>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteDomainModal;
